import React from 'react';
import Head from 'next/head';
import api from 'api/contact';
import { NextPage } from 'next';
import { connect } from 'react-redux';

import rootActions from '../redux/rootActions';
import { intro, infoMaps } from '../pages_data/contact';

import { FlexContainer } from '../components/common/FlexContainer';
import { GetInitialProps } from '../types/getInitialProps';
import { InfoMapBottom } from '../components/common/connectionLines/InfoMapBottom';
import { InfoMapTop } from '../components/common/connectionLines/InfoMapTop';
import { InfoMaps } from '../components/contact/InfoMaps';
import { Layout } from '../components/common/Layout';
import { LetsMeetBreaker } from '../components/lets-meet/LetsMeetBreaker/LetsMeetBreaker';
import { LetsMeet } from '../components/lets-meet/LetsMeet';
import { TransparentContainer } from '../components/common/TransparentContainer';

interface Props {
    data: {
        contactHeaderText: any;
        letsMeetProfile: any;
    };
    pathName: string;
}

const Contact: NextPage<Props> = (props) => {
    const { contactHeaderText, letsMeetProfile } = props.data;

    return (
        <Layout {...props}>
            <Head>
                <title>{`Werken bij Developers.nl | Let's meet`}</title>
            </Head>
            <FlexContainer>
                <TransparentContainer>
                    <LetsMeetBreaker
                        titleLeft
                        // TODO: Title and Subtitle should be added to the API
                        {...intro}
                        description={contactHeaderText}
                    />
                    <InfoMapTop />
                    <InfoMaps {...infoMaps} />
                    <InfoMapBottom />
                    <LetsMeet profile={letsMeetProfile} contact />
                </TransparentContainer>
            </FlexContainer>
        </Layout>
    );
};

Contact.getInitialProps = (ctx: GetInitialProps): any => {
    const { store } = ctx;

    if (store.getState().contact.data) {
        return {
            pathName: ctx.pathname,
        };
    }

    return api.data().then(
        (payload) => {
            store.dispatch(rootActions.fetchContactSuccess(payload));

            return {
                pathName: ctx.pathname,
            };
        },
        (response) => {
            const error = response.error || {
                message: response,
                code: 404,
            };

            store.dispatch(rootActions.fetchContactError(error));

            return {
                pathName: ctx.pathname,
            };
        },
    );
};

export default connect((state) => {
    return {
        data: state.contact.data,
    };
}, rootActions)(Contact);
